<template>
    <div>
        <q-card class="bg-primary text-white full-height" style="width: 100%;">
            <q-bar>
                <q-space />
                <q-btn
                    v-if="close !== false"
                    dense
                    flat
                    icon="close"
                    v-close-popup
                    @click="onClose"
                >
                    <q-tooltip content-class="bg-white text-primary"
                        >Close</q-tooltip
                    >
                </q-btn>
            </q-bar>

            <div class="row justify-center col-12 col-md-6 bg-primary">
                <q-card-section class="row col-12 col-sm-10 col-md-7">
                    <slot name="header"></slot>
                </q-card-section>

                <q-card-section class="q-pt-none row col-12 col-sm-10 col-md-7">
                    <div style="width:100%">
                        <slot></slot>
                    </div>
                </q-card-section>
            </div>
        </q-card>
    </div>
</template>

<script>
import { QCard, QCardSection, QSpace, QBar, QTooltip } from "quasar";
const components = {
    QCard,
    QCardSection,
    QSpace,
    QBar,
    QTooltip
};
export default {
    props: ["title", "btn-right", "btnRight2", "close"],
    components: {
        ...components,
    },
    methods: {
        onClickbtn() {
            this.$emit("on-confirm");
        },
        onClickbtn2() {
            this.$emit("on-express");
        },
        onClose(){
            this.$emit("on-close");
        }
    },
};
</script>

<style>

</style>
